import React from 'react';
import { Box, Grid, Paper, Typography, TableContainer, Table, TableBody, TableRow, TableCell } from '@mui/material';
import LineChart from './LineChart';

const ResultadosDetalhados = ({ resultData }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 3, borderRadius: 12, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', backgroundColor: '#fff' }}>
            <Typography variant="h5" component="h3" sx={{ 
              fontWeight: 600, 
              mb: 2, 
              color: '#121C42',
              fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' }
            }}>
              Patrimônio Líquido Acumulado em um Período de 10 anos
            </Typography>
            <Box sx={{ mt: 1, display: 'flex', gap: 3, mb: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: 10, height: 10, backgroundColor: '#121C42', mr: 1, borderRadius: '50%' }} />
                <Typography variant="caption" sx={{ 
                  fontSize: { xs: '0.6rem', sm: '0.65rem', md: '0.7rem' }, 
                  color: '#333' 
                }}>
                  Modelo tradicional
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: 10, height: 10, backgroundColor: '#FDA506', mr: 1, borderRadius: '50%' }} />
                <Typography variant="caption" sx={{ 
                  fontSize: { xs: '0.6rem', sm: '0.65rem', md: '0.7rem' }, 
                  color: '#333' 
                }}>
                  Modelo fee fixo
                </Typography>
              </Box>
            </Box>
            <Box sx={{ height: 280, width: '100%', border: '1px solid #333' }}>
              <LineChart data={resultData.chartData} />
            </Box>
            <TableContainer component={Box} sx={{ mb: 2 }}>
              <Table size="small" sx={{ minWidth: '100%', border: '1px solid #333', borderCollapse: 'separate' }}>
                <TableBody>
                  <TableRow>
                    {resultData.chartData.map((item, i) => (
                      <TableCell key={`header-${i}`} align="center" sx={{ 
                        fontSize: { xs: '0.65rem', sm: '0.7rem', md: '0.75rem' }, 
                        p: { xs: 0.5, sm: 0.6, md: 0.7 }, 
                        fontWeight: 500, 
                        color: '#333', 
                        borderBottom: '1px solid #e0e0e0', 
                        borderRight: i < resultData.chartData.length - 1 ? '1px solid #e0e0e0' : 'none' 
                      }}>
                        Ano {item.year}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    {resultData.chartData.map((item, i) => (
                      <TableCell key={`fee-${i}`} align="center" sx={{ 
                        fontSize: { xs: '0.55rem', sm: '0.6rem', md: '0.65rem' }, 
                        p: { xs: 0.5, sm: '0.6', md: 0.8 }, 
                        color: '#FDA506', 
                        fontWeight: 'bold', 
                        borderBottom: '1px solid #e0e0e0', 
                        borderRight: i < resultData.chartData.length - 1 ? '1px solid #e0e0e0' : 'none' 
                      }}>
                        {item.monefica.toLocaleString('pt-BR')}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    {resultData.chartData.map((item, i) => (
                      <TableCell key={`trad-${i}`} align="center" sx={{ 
                        fontSize: { xs: '0.55rem', sm: '0.6rem', md: '0.65rem' }, 
                        p: { xs: 0.5, sm: '0.6', md: 0.8 }, 
                        color: '#121C42', 
                        fontWeight: 'bold', 
                        borderRight: i < resultData.chartData.length - 1 ? '1px solid #e0e0e0' : 'none' 
                      }}>
                        {item.traditional.toLocaleString('pt-BR')}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Typography variant="caption" sx={{ 
              display: 'block', 
              mt: 2, 
              color: 'text.secondary', 
              fontSize: { xs: '0.65rem', sm: '0.68rem', md: '0.7rem' }
            }}>
              O mercado tradicional, a cobrança varia de 0,6% a 1,5% ao ano sobre o patrimônio.
              <br />
              Na Monefica, atuamos com fee fixo, sem comissões.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 4, height: '100%', borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.15)', backgroundColor: '#fff' }}>
            <Typography variant="h5" component="h3" sx={{ 
              fontWeight: 'bold', 
              color: '#121C42', 
              mb: 1,
              fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' }
            }}>
              Resultado
            </Typography>
            
            <Box sx={{ mb: 1 }}>
              <Typography variant="h6" sx={{ 
                color: '#666', 
                mb: 0.5,
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' }
              }}>
                Fee fixo
              </Typography>
              <Typography variant="h5" sx={{ 
                fontWeight: 'bold', 
                color: '#121C42', 
                fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.4rem' }
              }}>
                R${resultData.moneficaFee.toLocaleString('pt-BR')} por ano
              </Typography>
            </Box>
            
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6" sx={{ 
                color: '#666', 
                mb: 0.5,
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' }
              }}>
                Modelo tradicional
              </Typography>
              <Typography variant="h5" sx={{ 
                fontWeight: 'bold', 
                color: '#121C42', 
                fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.4rem' }
              }}>
                R${resultData.traditionalFee.toLocaleString('pt-BR')} por ano
              </Typography>
            </Box>
            
            <Box sx={{ 
              background: 'linear-gradient(15deg, #FDA506 0%, #FFFFFF 50%, #FDA506 100%)', 
              p: 2, 
              borderRadius: 4, 
              mb: 1,
              textAlign: 'left'
            }}>
              <Typography variant="h5" sx={{ 
                fontWeight: 'bold', 
                color: '#000', 
                mb: 0.5, 
                fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.4rem' }
              }}>
                Economia de
              </Typography>
              <Typography variant="h5" sx={{ 
                fontWeight: 'bold', 
                color: '#000', 
                fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.4rem' }
              }}>
                R${resultData.yearlyEconomy.toLocaleString('pt-BR')} por ano
              </Typography>
            </Box>
            
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ 
                color: '#666', 
                mb: 1.5,
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' }
              }}>
                Projeção de impacto ao longo de <strong>10 anos</strong>:
              </Typography>
              <Typography variant="h5" sx={{ 
                fontWeight: 'bold', 
                color: '#121C42', 
                fontSize: { xs: '1rem', sm: '1.15rem', md: '1.3rem' }, 
                lineHeight: 1.2 
              }}>
                Você pode economizar
              </Typography>
              <Typography variant="h5" sx={{ 
                fontWeight: 'bold', 
                color: '#121C42', 
                fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.4rem' }
              }}>
                R${resultData.totalEconomy.toLocaleString('pt-BR')}
              </Typography>
            </Box>
            
            <Typography variant="body2" sx={{ 
              color: '#666', 
              fontSize: { xs: '0.75rem', sm: '0.78rem', md: '0.8rem' }, 
              lineHeight: 1.4 
            }}>
              Mercado tradicional: entre 0,6% e 1,5% ao ano em comissões.
              <br />
              Na Monefica: fee fixo, sem comissão e sem conflito de interesse.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ResultadosDetalhados; 